// Patient / family feedback shown on the home page.
const testimonials = [
  {
    id: 1,
    name: "Abdul Karim",
    relation: "Patient Family",
    image: "/assets/images/testimonials/thumbs/1.png",
    rating: 5,
    text: "The doctors and therapists showed deep understanding and professionalism throughout the treatment process. Their compassionate approach helped our family feel safe, informed, and supported during a very difficult time.",
  },
  {
    id: 2,
    name: "Rahim Uddin",
    relation: "Recovered Patient",
    image: "/assets/images/testimonials/thumbs/2.png",
    rating: 5,
    text: "The medical team provided structured psychiatric care and constant monitoring that helped me regain stability. The counseling sessions and supportive environment played a major role in my recovery journey.",
  },
  {
    id: 3,
    name: "Sadia Rahman",
    relation: "Family Member",
    image: "/assets/images/testimonials/thumbs/3.png",
    rating: 5,
    text: "Unity Health Centre treated our loved one with dignity and respect. The doctors, nurses, and counselors worked together to create a clear treatment plan and kept us involved throughout.",
  },
  {
    id: 4,
    name: "Mahmud Hasan",
    relation: "Former Patient",
    image: "/assets/images/testimonials/thumbs/2.png",
    rating: 5,
    text: "The addiction rehabilitation program was well-structured and medically supervised. Therapy sessions helped me understand my triggers and develop healthier coping strategies.",
  },
  {
    id: 5,
    name: "Nusrat Jahan",
    relation: "Patient Family",
    image: "/assets/images/testimonials/thumbs/3.png",
    rating: 4,
    text: "From admission to discharge, the care team maintained confidentiality and professionalism. Their guidance and family counseling sessions made recovery feel possible and hopeful.",
  },
];

// Rating badge shown beside the testimonials
export const ratingSummary = {
  value: 4.9,
  label: "Patient Satisfaction Rating",
  note: ", based on verified feedback.",
};

export default testimonials;
